import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ChevronRight, AlertTriangle } from "lucide-react";
import DynamicForm from "@/pages/DynamicForm";

function ReportFallback() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith("en") ? "en" : "fr";
  return (
    <div className="min-h-screen bg-[#050814]" data-testid="report-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <nav className="flex items-center gap-2 text-sm text-[#94A3B8] mb-8">
          <Link to="/" className="hover:text-white transition-colors">{lang === "fr" ? "Accueil" : "Home"}</Link>
          <ChevronRight size={14} />
          <span className="text-[#FFC928]">{t("pages.reportTitle")}</span>
        </nav>
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4" style={{ fontFamily: "Poppins" }} data-testid="report-title">
          {t("pages.reportTitle")}
        </h1>
        <p className="text-[#94A3B8] text-sm flex items-start gap-2">
          <AlertTriangle size={16} className="text-amber-400 mt-0.5" />
          {lang === "fr"
            ? "Le formulaire de signalement est momentanément indisponible. Réessayez plus tard."
            : "The report form is temporarily unavailable. Please try again later."}
        </p>
      </div>
    </div>
  );
}

export default function Report() {
  return <DynamicForm formKey="report_problem" fallback={<ReportFallback />} />;
}
